import React from "react";
import ListContent from "../../components/ListContent";
import HeroContent from "../../components/HeroContent";
import HeroMedia from "../../components/HeroMedia";
import IconContent from "../../components/IconContent";
import LargeImageContent from "../../components/Large-Image-Content";
import QuoteContent from "../../components/QuoteContent";
import TextContent from "../../components/TextContent";
import TwoImagesContent from "../../components/TwoImagesContent";

/**
 * @return {string}
 */

export default function Wrapper({ fields }) {
  const { component, datasource } = fields;
  let componentValue =
    component &&
    component.fields &&
    component.fields.phrase &&
    component.fields.phrase.value &&
    component.fields.phrase.value.toLowerCase();
  switch (componentValue) {
    case "listcontent":
      return (
        <ListContent
          fields={datasource.fields}
          rendering={{ dataSource: datasource.id }}
        />
      );
    case "herocontent":
      return (
        <HeroContent
          fields={datasource.fields}
          rendering={{ dataSource: datasource.id }}
        />
      );
    case "heromedia":
      return (
        <HeroMedia
          fields={datasource.fields}
          rendering={{ dataSource: datasource.id }}
        />
      );
    case "iconcontent":
      return (
        <IconContent
          fields={datasource.fields}
          rendering={{ dataSource: datasource.id }}
        />
      );
    case "largeimagecontent":
      return (
        <LargeImageContent
          fields={datasource.fields}
          rendering={{ dataSource: datasource.id }}
        />
      );
    case "quotecontent":
      return (
        <QuoteContent
          fields={datasource.fields}
          rendering={{ dataSource: datasource.id }}
        />
      );
    case "textcontent":
      return (
        <TextContent
          fields={datasource.fields}
          rendering={{ dataSource: datasource.id }}
        />
      );
    case "twoimagescontent":
      return (
        <TwoImagesContent
          fields={datasource.fields}
          rendering={{ dataSource: datasource.id }}
        />
      );
    default:
      return "";
  }
}
